/*
 * Public API Surface of phone
 */

export * from './lib/phone.service';
export * from './lib/phone.component';
export * from './lib/phone.module';
